import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import { useGlobalStore } from "../contexts/globalStoreContext";
import { useInterceptors, useNavigateCustom } from "../hooks";
import { StoreNameEnum } from "../enum/storesEnum";
import { decryptRoute } from "../utils/encryption";

const ProtectedRoute: React.FC = observer(() => {
	useInterceptors();
	const { authenticationStore } = useGlobalStore();
	const navigate = useNavigateCustom();
	const location = useLocation();

	const lastRouteEncrypted = sessionStorage.getItem(StoreNameEnum.LAST_ROUTE);
	const lastRoute = lastRouteEncrypted ? decryptRoute(lastRouteEncrypted) : "/";

	const handleRouteChange = (): void => {
		if (!authenticationStore.isAuthenticated) {
			return navigate("/login", { replace: true });
		}

		if (!location.state?.isInternalNavigation) {
			return navigate(lastRoute || "/", { replace: true });
		}
	};

	useEffect(() => {
		handleRouteChange();
	}, [location.pathname]);

	return (
		<>
			<Outlet />
			<ScrollRestoration />
		</>
	);
});

export default ProtectedRoute;
